<div id="logo-container" class="flex pr-10">
  <a [id]="isLogin() ? 'header-logo-authorized' : 'header-logo-unauthorized'"
     [routerLink]="[isLogin() ? '/dashboard' : '/sign-in']" class="-m-1.5 p-1.5">
    <span class="sr-only">Renew Biomedical</span>
    <img class="h-10 w-auto min-w-[115px]"
         ngSrc="https://prod-biomed-retool-attachments.s3.us-east-1.amazonaws.com/logo/renew.png"
         alt="logo" width="115" height="40">
  </a>
</div>
